

<template>
  <div class="collapse collapse-item" :class="{ 'is-active': active }">
    <div class="collapse-header touchable" role="tab" :aria-expanded="active ? 'true' : 'false'" @click.prevent="toggle">
      <slot name="collapse-header"></slot>
    </div>
    <transition name="fade">
      <div class="collapse-body" v-if="active">
        <div class="collapse-content-box">
          <slot name="collapse-body"></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    name: "Collapse",
    data(){
      return {
        active: false
      }
    },
    props: {
      selected: {
        type: Boolean,
        required: true,
        default: false
      }
    },
    created () {
      this._isCollapseItem = true;
      this.active = this.selected
    },
    ready () {
      if (this.active) {
        this.$emit('collapse-open', this.index)
      }
    },
    methods: {
      toggle () {
        this.active = !this.active;
        if (this.active) {
          this.$emit('collapse-open', this.index)
        }
      }
    }
  }
</script>

<style lang="scss">
  .collapse {
    margin-bottom: 20px;
    &-header {;
      position: relative;
      padding-bottom: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      line-height: 1.1;

      h3 {
        font-size: 0.938em;
        font-weight: bold;
      }

      &::after {
        content: '';
        $size: 30px;
        display: block;
        flex: 0 0 30px;
        background: url('../assets/images/arrow.png');
        background-size: contain;
        width: $size;
        height: $size;
        margin-left: 1em;
        transition: all .2s ease;
      }
    }
    &-content-box {
      color: var(--color-gray);
      strong {
        color: var(--color-black);
      }
    }
    &.is-active .collapse-header::after {
      transform: scaleY(-1);
    }
  }
</style>
